module.exports = __webpack_public_path__ + "img/5.b837042f.png";